import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.colors.blueLight,
    height: toRem(100),
    width: '100%',
    borderRadius: 4,
    padding: toRems([0, 5]),

    [theme.breakpoints.up('md')]: {
        height: toRem(150)
    },
    [theme.breakpoints.up('lg')]: {
        height: toRem(150),

        '&:hover': {
            '.Icon': {
                transform: 'scale(1.25, 1.25)'
            }
        }
    },
    [theme.breakpoints.up('xl')]: {
        height: toRem(200)
    },
    '& .ManageItemInner': {
        textAlign: 'center',
        color: theme.colors.white
    },
    '& .Icon': {
        display: 'block',
        marginBottom: 0,
        transition: 'transform 0.5s ease',
        [theme.breakpoints.up('md')]: {
            marginBottom: toRem(25)
        },
        svg: {
            width: toRem(40),
            [theme.breakpoints.up('xl')]: {
                width: toRem(60)
            }
        }
    },
    '& .Text': {
        fontSize: toRem(11),
        [theme.breakpoints.up('md')]: {
            fontSize: toRem(14)
        }
    }
})

export default style
